import { render } from "./AcceptLicenseOrderAction.vue?vue&type=template&id=214cdcdd"
import script from "./AcceptLicenseOrderAction.vue?vue&type=script&lang=js"
export * from "./AcceptLicenseOrderAction.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__